import React from "react";
import Typewriter from "typewriter-effect";
import images from "../../assets/images";
import "./style.css";

const Introduction = () => {
  const { foto1, foto2 } = images.introduction;

  return (
    <section id="couple">
      <div className="container">

        <div className="intro-header" data-aos="fade-up">
          <h2 className="intro-title">Nos Casamos</h2>
          <div className="intro-rule"></div>
          <p className="intro-date">19 · Septiembre · 2026</p>
        </div>

        <div className="intro-couple" data-aos="fade-up" data-aos-delay="100">

          <div className="intro-person">
            <div className="intro-photo-wrap">
              <img className="intro-photo" src={foto1} alt="Miguel" />
            </div>
            <h3 className="intro-name">Miguel Calderón</h3>
            <p className="intro-role">El Novio</p>
            <div className="intro-person-rule"></div>
            <div className="intro-typewriter">
              <Typewriter
                options={{
                  strings: ['"Eres mi Lucero, la luz que guía cada uno de mis pasos, Cuando todo parecía incierto, apareciste tú, Tu amor ilumina en mí lo que no sabía que existía y desde ese día supe que sería para siempre."'],
                  autoStart: true,
                  loop: true,
                  delay: 95,
                  deleteSpeed: 35,
                }}
              />
            </div>
          </div>

          <div className="intro-ampersand" data-aos="zoom-in" data-aos-delay="200">
            &amp;
          </div>

          <div className="intro-person">
            <div className="intro-photo-wrap">
              <img className="intro-photo" src={foto2} alt="Lucero" />
            </div>
            <h3 className="intro-name">Lucero Ramírez</h3>
            <p className="intro-role">La Novia</p>
            <div className="intro-person-rule"></div>
            <div className="intro-typewriter">
              <Typewriter
                options={{
                  strings: ['"Elegirte todos los días es la mejor decisión que he tomado, iniciamos una nueva etapa con la certeza de que somos el mejor equipo, gracias por ser mi compañero de aventuras, por tu apoyo incondicional y por construir este proyecto de vida conmigo. El futuro se ve increíble a tu lado, te elijo siempre."'],
                  autoStart: true,
                  loop: true,
                  delay: 95,
                  deleteSpeed: 35,
                }}
              />
            </div>
          </div>

        </div>
      </div>
    </section>
  );
};

export default Introduction;
